import { FC } from 'react'
import GlobeSvg from '@/public/images/common/globe-01_v2.svg'
import ArrowSvg from '@/public/images/common/arrow-up-right_v2.svg'
import Link from 'next/link'
import styles from './index.module.scss'

type Props = {
  url: string
}

export const ProfileWebsiteLink: FC<Props> = ({ url }) => {
  return (
    <div className={styles.container}>
      <div className={styles.globeIcon}>
        <GlobeSvg viewBox='0 0 24 24' />
      </div>
      <Link href={url}>
        <a target='_blank' rel='noopener noreferrer' className={styles.link}>
          <div className={styles.text}>{url}</div>
          <div className={styles.arrowIcon}>
            <ArrowSvg viewBox='0 0 24 24' />
          </div>
        </a>
      </Link>
    </div>
  )
}
